import { Action, createHook, createStore } from 'react-sweet-state'

import { IAccount } from '../api/users'
import { IRoleEnum } from '../types/router'

type IUserProfileState = {
    userProfile: IAccount
}

const userProfileInitialState: IUserProfileState = {
    userProfile: {
        id: '',
        username: '',
        email: '',
        role: IRoleEnum.USER,
        capabilities: { can_delete_faq: false },
    },
}

const userProfileActions = {
    setMyProfile:
        (userProfile: IAccount): Action<IUserProfileState> =>
        ({ setState }) => {
            setState({ userProfile })
        },
    editMyProfileName:
        (username: string): Action<IUserProfileState> =>
        ({ setState, getState }) => {
            const userProfile = getState().userProfile

            if (!userProfile) return

            setState({ userProfile: { ...userProfile, username } })
        },
    editMyProfileEmail:
        (email: string): Action<IUserProfileState> =>
        ({ setState, getState }) => {
            const userProfile = getState().userProfile

            if (!userProfile) return

            setState({ userProfile: { ...userProfile, email } })
        },
}

const Store = createStore({
    initialState: userProfileInitialState,
    actions: userProfileActions,
})

export const useUserProfileStore = createHook(Store)
